import React from 'react';

const PEPartnershipStrip = () => (
    <section className="lp-pe-strip">
        <div className="lp-pe-strip-inner">
            <div className="lp-pe-strip-brand">
                <img src={require('../../../../images/landing-pages/PE/morsebridge-icon.png')} alt="Morsebridge" />
                <span>MORSEBRIDGE</span>
            </div>
            <p>Diligentsia leads on dealflow, diligence and portfolio value. Diligentsia's platform layer for private equity firms is delivered in partnership with Morsebridge, the agent layer for PE deal teams.</p>
        </div>
    </section>
);

export default PEPartnershipStrip;
